import * as React from "react";
const CloseLarge = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 8 8", fill: "currentColor", width: size || "8", height: size || "8", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7.2 0 4 3.2.8 0 .1.7 3.3 4 0 7.3.7 8 4 4.7 7.3 8 8 7.3 4.7 4 7.9.7z" }));
CloseLarge.displayName = "CloseLarge";
var CloseLarge_default = CloseLarge;
export {
  CloseLarge_default as default
};
